var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-tabs text-center"},_vm._l((_vm.tabs),function(tab){return _c('v-btn',{key:tab.value,class:['normal-btn primary-color', {'active-tab': _vm.currentTab === tab.value}],attrs:{"depressed":"","text":""},on:{"click":function($event){_vm.currentTab = tab.value}}},[_vm._v(" "+_vm._s(tab.name)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }